import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 0 1.5rem;
`;

const Message = styled.p`
  margin: 0;
  text-align: center;
  white-space: pre-line;
`;

export default function TechnicalMessage({ message }) {
  return (
    <Container>
      <Message>{message}</Message>
    </Container>
  );
}
